import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
    selector: 'message-timestamp',
    templateUrl: './message-timestamp.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageTimestampComponent {
    public readonly occurredAtTimestamp = input<number>(0);
    public readonly fromClient = input<boolean>(false);

    public readonly formattedTime = computed(() => {
        const timestampMs = this.occurredAtTimestamp() / 1000;
        const date = new Date(timestampMs);

        return date.toLocaleString('nl-NL', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            timeZone: 'Europe/Amsterdam'
        });
    });
}
